export default "__VITE_ASSET__Cyo3O01q__"